<template>
    <div
        class="investment-strategy-change-notification__wrapper d-flex align-self-start"
        :class="{
            'investment-strategy-change-notification__wrapper--no-margin':
                this.tense === 'past',
        }">
        <div
            class="investment-strategy-change-notification__box d-inline-flex flex-row w-100">
            <Icon
                class="investment-strategy-change-notification__icon d-flex"
                :type="'error'"
                :width="25"
                :height="25" />
            <div class="investment-strategy-change-notification__text d-flex">
                <i18next
                    :path="textTranslationPath"
                    tag="span">
                    <span
                        place="currentStrategy">”{{ this.currentInvestmentStrategyName }}”</span>
                    <span
                        place="newStrategy">”{{ this.newInvestmentStrategyName }}”</span>
                </i18next>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'InvestmentStrategyChangeNotification',
    props: {
        tense: {
            type: String,
            validator: val => ['past', 'future'].includes(val),
            default: 'past',
        },
    },
    computed: {
        ...mapGetters([
            'previousInvestmentStrategySelected',
            'investmentStrategySelected',
            'investmentStrategyRecommendedBasedOnRiskTolerance',
        ]),
        textTranslationPath () {
            return `investmentStrategyChange.${this.tense}Tense.text`;
        },
        investmentStrategyName () {
            return this.$t(
                `investmentStrategyType.${this.investmentStrategySelected.name}.title`,
            );
        },
        recommendedInvestmentStrategyName () {
            return this.investmentStrategyRecommendedBasedOnRiskTolerance
                ? this.$t(
                    `investmentStrategyType.${this.investmentStrategyRecommendedBasedOnRiskTolerance.name}.title`,
                )
                : '';
        },
        previousInvestmentStrategyName () {
            return this.previousInvestmentStrategySelected
                ? this.$t(
                    `investmentStrategyType.${this.previousInvestmentStrategySelected.name}.title`,
                )
                : '';
        },
        currentInvestmentStrategyName () {
            if (this.tense === 'past') {
                return this.previousInvestmentStrategyName;
            } else if (this.tense === 'future') {
                return this.investmentStrategyName;
            } else {
                // TODO fix this
                return '';
            }
        },
        newInvestmentStrategyName () {
            if (this.tense === 'past') {
                return this.investmentStrategyName;
            } else if (this.tense === 'future') {
                return this.recommendedInvestmentStrategyName;
            } else {
                // TODO fix this
                return '';
            }
        },
    },
};
</script>

<style scoped lang="scss">
.investment-strategy-change-notification__wrapper {
  height: 45px;
  margin: 20px 0 0 0;

  @include media-breakpoint-down(xs) {
    margin: 15px 0 15px 0;
    min-height: 45px;
    height: auto;
  }
}

.investment-strategy-change-notification__wrapper--no-margin {
  margin-top: 0;
  margin-bottom: 20px;
}

.investment-strategy-change-notification__box {
  background: $mb-grey5;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
  color: $white;
  padding-left: 0;
  padding-right: 0;

  @include media-breakpoint-down(xs) {
    padding: 10px;
  }
}

.investment-strategy-change-notification__icon {
  margin: 10px 15px 10px 15px;

  ::v-deep svg > g {
    stroke: $white;
  }

  @include media-breakpoint-down(xs) {
    margin: 0 10px 0 0;
  }
}

.investment-strategy-change-notification__text {
  @include font-migrosbank();
  color: $white;
  font-size: 14px;
  line-height: 22px;
  align-items: center;
  margin-right: 15px;

  @include media-breakpoint-down(xs) {
    line-height: 16px;
    margin-right: 10px;
  }

  span[place] {
    @include font-migrosbank-bold();
  }
}
</style>
